export default __webpack_public_path__ + "static/hero_left-8b84d2f54e819a0424e38da8e2c7841e.png";